import { useMemo } from "react"
import { useAllProducts } from "../../hooks/products"
import {
  Center,
  Spinner,
  Table,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react"

const OrderPivot = ({ items, showEmpty }) => {
  const { products, isLoading } = useAllProducts()
  const sums = useMemo(() => {
    var tempSums = {}
    items.forEach((order) => {
      Object.values(order.cart).forEach((cartItem) => {
        if (!(cartItem.id in tempSums)) {
          tempSums[cartItem.id] = 0
        }
        tempSums[cartItem.id] += cartItem.qty
      })
    })
    return tempSums
  }, [items])

  return isLoading ? (
    <Center>
      <Spinner />
    </Center>
  ) : (
    <Table variant="striped" size="sm">
      <Thead>
        <Tr>
          <Th>Prodotto</Th>
          <Th isNumeric>Quantità</Th>
        </Tr>
      </Thead>
      <Tbody>
        {products.map((product) => {
          const total = sums?.[product.id] || 0
          return total > 0 || showEmpty ? (
            <Tr key={product.id}>
              <Td>{product.name}</Td>
              <Td isNumeric color={total > 0 ? "green.500" : "gray.300"}>
                <strong>{total}</strong>
              </Td>
            </Tr>
          ) : null
        })}
      </Tbody>
      <Tfoot>
        <Tr>
          <Th>Prodotto</Th>
          <Th isNumeric>Quantità</Th>
        </Tr>
      </Tfoot>
    </Table>
  )
}

export default OrderPivot
